import React from 'react';
import { motion } from 'framer-motion';

/**
 * CyberButton — mechanical, high-stakes architect-grade CTA.
 * Two corner-drawn borders sweep in on hover, plus a Hyper-Cyan glow
 * and a subtle glitch-in on the label.
 */
export default function CyberButton({
  children,
  onClick,
  variant = 'primary',
  size = 'md',
  className = '',
  href,
  target,
  ...props
}) {
  const base =
    'group btn-mech glitch-hover relative inline-flex items-center justify-center font-mono uppercase tracking-[0.2em] cursor-pointer select-none border transition-all duration-200';

  const variants = {
    primary: 'bg-transparent border-[rgba(0,240,255,0.35)] text-[var(--hyper-cyan)] hover:text-white',
    secondary: 'bg-transparent border-white/18 text-white/75 hover:text-white hover:border-[rgba(0,240,255,0.55)]',
    accent: 'bg-[var(--hyper-cyan)] border-[var(--hyper-cyan)] text-black hover:bg-[#7DF9FF]',
  };
  const sizes = {
    sm: 'px-4 py-2 text-[10px]',
    md: 'px-6 py-3 text-xs',
    lg: 'px-8 py-4 text-[13px]',
  };

  const Component = href ? motion.a : motion.button;

  return (
    <Component
      href={href}
      target={target}
      onClick={onClick}
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      whileTap={{ scale: 0.97 }}
      {...props}
    >
      {/* Mechanical scan line on top — only for primary/secondary */}
      {variant !== 'accent' && (
        <>
          <span className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-px w-0 group-hover:w-full bg-gradient-to-r from-transparent via-[var(--hyper-cyan)] to-transparent transition-[width] duration-500" />
          <span className="pointer-events-none absolute bottom-0 left-1/2 -translate-x-1/2 h-px w-0 group-hover:w-full bg-gradient-to-r from-transparent via-[var(--hyper-cyan)] to-transparent transition-[width] duration-500" />
        </>
      )}

      <span className="glitch-target relative z-10 flex items-center justify-center gap-2 font-semibold">
        {children}
      </span>
    </Component>
  );
}
